import React, { useEffect } from 'react'
import { useMappedState, useDispatch } from 'redux-react-hook';
import Button from '@material-ui/core/Button';
import { TextField } from 'material-ui';
import 'react-toastify/dist/ReactToastify.css';
import { FetchContact, GetContact, SaveContact } from '../../store/contact/actions';

const style = {
    height: 500,
    width: 400,
    margin: 20,
    textAlign: 'center',
    display: 'inline-block'
};

const padding = {
    padding: 10
}

const mapState = state => ({
  contact: state.contact,
});

const ContactComponent = () => {
  const dispatch = useDispatch();
  const { contact } = useMappedState(mapState);

  const saveContact = () => {
    dispatch(SaveContact(contact))
  }

  useEffect(() => {
    if(!contact.touched) dispatch(FetchContact());
  }, []);

  const handleChangeTelefon1 = (e) =>{
    const newContact = { ...contact, tel1: e.target.value }
    dispatch(GetContact(newContact))
  }

  const handleChangeTelefon2 = (e) =>{
    const newContact = { ...contact, tel2: e.target.value }
    dispatch(GetContact(newContact))
  }

  const handleChangeEmail = (e) =>{
    const newContact = { ...contact, email: e.target.value }
    dispatch(GetContact(newContact))
  }

  return (
    <div style={style}>
      <h2>Moje dane kontaktowe (do kontaktu ze strony Operatora)</h2>
      <div><TextField floatingLabelText="telefon 1" value={contact.tel1} onChange={handleChangeTelefon1} /></div>
      <div><TextField floatingLabelText="telefon 2" value={contact.tel2} onChange={handleChangeTelefon2} /></div>
      <div><TextField floatingLabelText="e-mail" value={contact.email} onChange={handleChangeEmail} /></div>
        <div style={padding}><Button variant="raised" color="primary" onClick={saveContact}>Zapisz</Button></div>
    </div>
  );
}

export default ContactComponent;


// WEBPACK FOOTER //
// ./src/components/Contact/ContactComponent.js